
import Component from 'flarum/Component'
import humanTime from 'flarum/utils/humanTime'
import Siema from 'siema'

export default class Banners extends Component {
  oninit(vnode) {
    super.oninit(vnode)

    app.banners.load()

    this.index = 0
  }

  view() {
    this.itemArr = app.banners.cache

    if (this.itemArr === undefined) return null

    let list = []
    
    this.itemArr.map(val => {
      list.push(
        <div class="position-relative">
          <figure class="embed-responsive">
            <picture class="picture position-absolute">
              <source media="(max-width: 768px)" sizes="(max-width: 768px) 100vw, 768px" srcset={val.imageMob()} />
              <img class="img-fluid"  src={val.image()} alt="" />
            </picture>
          </figure>
          <div class="text-and-action-overlay position-absolute">
            <div class="align-items-center d-flex h-100">
              <div class="space-responsive">
                <h4 class="title">{ val.title() }</h4>
                <div>
                  <a class="Button" 
                    href={ val.link() }>{ val.btnText() }</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
    return (
      <header className="Hero TagHero container banner-container">
        <div class="w-100 position-relative Hero-box">
          <div class="siema" id="siema">
            {
              list
            }
          </div>
          <ul class="position-absolute dots">
            {
              this.itemArr.map((val, index) => 
                <li class='dot as-dot'onclick={this.toIndex.bind(this, index)}></li>
              )
            }
          </ul>
          <div class="carousel-control-wrapper">
            <a class="carousel-control-prev as-carousel-prev" role="button" onclick={this.toPrev.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 47 46">
                <g transform="translate(264.44 -1847.44) rotate(90)">
                  <path fill="none" d="M14.319,0,0,14.319,14.319,28.638" transform="translate(1855.905 245.879) rotate(-90)" style="stroke-width:3px;" />
                </g>
              </svg>
            </a>
            <a class="carousel-control-next as-carousel-next" role="button" onclick={this.toNext.bind(this)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 47 46">
                <g transform="translate(-217.44 1893.44) rotate(-90)">
                  <path fill="none" d="M14.319,0,0,14.319,14.319,28.638" transform="translate(1855.905 245.879) rotate(-90)" style="stroke-width:3px;" />
                </g>
              </svg>
            </a>
          </div>
        </div>
      </header>
    )
  }

  toPrev() {
    this.siema.prev()
  }

  toNext() {
    this.siema.next()
  }
  
  toIndex(i) {
    this.siema.goTo(i)
  }
  onupdate() {
    let that = this
    if (this.itemArr?.length > 0 && !this.done) {
      // 给第一个dot 添加样式
      const $dom = document.querySelector('.as-dot')
      $dom && $dom.classList.add('active')
      this.siema = new Siema({
        selector: document.querySelector('#siema'),
        loop: true,
        onChange: function () {
          // console.log(this.currentSlide)
          // 移动端滚动事件没办法实时监听
          if (that.index != this.currentSlide) {
            that.changeDotStyle(this.currentSlide)
          }
          that.index = this.currentSlide
        }
      })
      this.done = true
    }
  }

  changeDotStyle(i) {
    document.querySelector('.as-dot.active') && document.querySelector('.as-dot.active').classList.remove('active')
    const $dom = document.querySelectorAll('.as-dot')
    $dom[i].classList.add('active')
  }

}